import * as React from "react";
import { connect } from "react-redux";
import PlanDetailDashboard from "./PlanDashboard";
import PlanDetailPage from "./PlanDetail";
import { fetchPlanDetail } from "../../actions/planDetailAction";
import Loader from "../Common/Loader";
import { SCCustomerNavigation } from "./css";
import history from "../../history";
import { NavWithComponent } from "../Nav";

class ViewPlan extends React.Component<any, any> {
  handleMakeAPayemnt() {
    history.push("/payments");
  }

  componentDidMount() {
    this.props.dispatch(fetchPlanDetail(this.props.match.params.id));
  }

  render() {
    const { error, loading, planDetail } = this.props;

    // Object for plan Dashboard
    const planDashBoardData = {
      planName: planDetail.name,
      storeName: planDetail.storeName,
      paymentFrequency: planDetail.estimateRepaymentRemaining,
      paidAmount: planDetail.paidAmount,
      remainingBalance: planDetail.remainingBalance,
      planStatus: planDetail.status && planDetail.status.toLowerCase(),
      icon: ""
    };

    if (error != null) {
      return <div>Error! {error.message}</div>;
    }

    if (loading) {
      return <Loader text="Loading...." />;
    }

    return (
      <>
      <NavWithComponent title="Plan Details" activePage="/my-plans" previousPagePath={'/my-plans'} />
      <SCCustomerNavigation>
        <PlanDetailDashboard planDashBoardData={planDashBoardData} />
        <PlanDetailPage planDetailPageData={planDetail} />
      </SCCustomerNavigation>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    planDetail: state.planDetail.planDetailData,
    loading: state.planDetail.loading,
    error: state.planDetail.error
  };
};

export default connect(mapStateToProps)(ViewPlan);
